module.exports = __webpack_public_path__ + "img/mini_arrow_shack_active.1f1736d8.svg";